import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { PDFViewer } from "@react-pdf/renderer";
import OldPurchasePDF from "../components/OldPurchasePDF";
import { showPurchase, listCustomerUsers, isErpApiSuccess } from "../erpClient";
import { extractCustomerUsersArray } from "../utils/customerUsersErpAdapter";
import { toast } from "react-hot-toast";
import { useButtonTableStyle } from "../utils/useButtonTableStyle";

function OldPurchasePDFView() {
  const { buttonClass } = useButtonTableStyle();
  const location = useLocation();
  const navigate = useNavigate();
  const [purchaseData, setPurchaseData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const purchaseId = location.state?.purchaseId;

  useEffect(() => {
    if (!purchaseId) {
      toast.error("Purchase ID not provided");
      navigate("/metalpurchasetable");
      return;
    }

    fetchPurchaseData();
  }, [purchaseId]);

  const fetchPurchaseData = async () => {
    setIsLoading(true);
    try {
      const response = await showPurchase({ id: purchaseId });
      const root = response?.data ?? response;

      if (isErpApiSuccess(response) || response?.message === "radha") {
        let purchaseDetails = null;
        if (Array.isArray(root?.purchase_details)) {
          purchaseDetails = root.purchase_details[0];
        } else if (root?.purchase_details && !Array.isArray(root.purchase_details)) {
          purchaseDetails = root.purchase_details;
        } else if (Array.isArray(root?.data?.purchase_details)) {
          purchaseDetails = root.data.purchase_details[0];
        } else if (root?.data?.purchase_details && !Array.isArray(root.data.purchase_details)) {
          purchaseDetails = root.data.purchase_details;
        }

        if (!purchaseDetails) {
          toast.error("Purchase data not found");
          navigate("/metalpurchasetable");
          return;
        }

        // Fetch customer details
        let customer = null;
        if (purchaseDetails.user_id) {
          try {
            const custRes = await listCustomerUsers({ search: "" });
            const custRows = extractCustomerUsersArray(custRes) || [];
            if (custRows.length) {
              customer = custRows.find(
                (c) => String(c.id) === String(purchaseDetails.user_id),
              );
            }
          } catch (error) {
            console.error("Error fetching customer:", error);
          }
        }

        // Format date
        const formatDate = (dateString) => {
          if (!dateString) return "";
          const date = new Date(dateString);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
        };

        // Prepare data for PDF
        const formattedData = {
          invoiceNumber: purchaseDetails.purchase_no || "",
          date: formatDate(purchaseDetails.bill_date || purchaseDetails.date),
          customer: customer || {
            name: "N/A",
            mobile: "N/A",
            city: "AHMEDABAD",
          },
          items: purchaseDetails.items || [],
          payments: purchaseDetails.purchase_payments || [],
          note: purchaseDetails.note || "",
          previousAmount: purchaseDetails.previous_amount || "",
          previousGold: purchaseDetails.previous_gold || "0",
          outstandingGold: purchaseDetails.outstanding_gold || "0.00",
        };

        setPurchaseData(formattedData);
      } else {
        toast.error(response?.message || "Failed to load purchase data");
        navigate("/metalpurchasetable");
      }
    } catch (error) {
      console.error("Error fetching purchase data:", error);
      toast.error("Failed to load purchase data");
      navigate("/metalpurchasetable");
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="body-wrapper">
        <div className="container-fluid">
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!purchaseData) {
    return null;
  }

  return (
    <div className="body-wrapper">
      <div className="container-fluid">
        <div className="card w-100 position-relative overflow-hidden">
          <div className="px-4 py-3 border-bottom d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">URD Invoice PDF</h4>
            <Button variant="secondary" className={buttonClass} onClick={() => navigate("/metalpurchasetable")}>
              Close
            </Button>
          </div>
          <div className="card-body p-0" style={{ height: "85vh", overflow: "auto" }}>
            <PDFViewer width="100%" height="100%">
              <OldPurchasePDF purchaseData={purchaseData} />
            </PDFViewer>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OldPurchasePDFView;

